import React from 'react';
import { Link } from 'react-router-dom';
import { useBallparkController } from './BallparkController';
import BallparkHeader from './components/BallparkHeader';
import BallparkOverview from './components/BallparkOverview';
import BallparkGameView from './components/BallparkGameView';
import BallparkTabView from './components/BallparkTabView';
import './components/ballpark.css';
import GameSelector from '../Retail/components/GameSelector';
import Spinner from '../../components/atoms/Spinner';
import BallparkIconBlack from '../../assets/bp_logo_black.svg';
import { getUserTeam } from '../../util';

function Ballpark() {
  const props = useBallparkController();

  const {
    authCtx,
    loading,
    error,
    viewMode,
    ballparkAccess,
  } = props;

  // Not logged in
  if (!authCtx.loggedIn) {
    return (
      <div className="p-4">
        <Link to="/auth">
          Not Authorized. Please Log-In with given credentials or contact support.
        </Link>
      </div>
    );
  }

  // Checking ballpark access
  if (ballparkAccess.loading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh'
      }}>
        <Spinner size="large" />
      </div>
    );
  }

  // Venue doesn't have ballpark enabled
  if (!ballparkAccess.venueEnabled) {
    return (
      <div className="page-content">
        <div 
          className="d-flex flex-column align-items-center justify-content-center" 
          style={{ minHeight: '70vh', padding: '2rem' }}
        >
          <div 
            style={{ 
              background: '#f8fafc', 
              borderRadius: '20px', 
              padding: '3rem', 
              textAlign: 'center',
              maxWidth: '500px',
              border: '1px solid #e5e7eb'
            }}
          >
            <div 
              style={{ 
                width: '80px', 
                height: '80px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}
            >
              <img src={getUserTeam(authCtx.league, authCtx.venue).imgURL} alt="logo" style={{height: '64px',marginRight: '16px', objectFit: 'contain'}}/>
              <img src={BallparkIconBlack} alt="Ballpark" style={{ width: '64px', height: '64px' }} />
            </div>
            <h3 style={{ color: '#1f2937', marginBottom: '1.0rem', fontWeight: '600' }}>
              Ballpark Integration
            </h3>
            <p style={{ color: '#6b7280', marginBottom: '1.0rem', lineHeight: '1.6' }}>
              Please contact your administrator or reach out to Queues to get started.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // User doesn't have ballpark access permission
  if (!ballparkAccess.userBallparkEnabled) {
    return (
      <div className="page-content">
        <div 
          className="d-flex flex-column align-items-center justify-content-center" 
          style={{ minHeight: '70vh', padding: '2rem' }}
        >
          <div 
            style={{ 
              background: '#f8fafc', 
              borderRadius: '20px', 
              padding: '3rem', 
              textAlign: 'center',
              maxWidth: '500px',
              border: '1px solid #e5e7eb'
            }}
          >
            <div 
              style={{ 
                width: '80px', 
                height: '80px', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                margin: '0 auto 1.5rem'
              }}
            >
              <img src={BallparkIconBlack} alt="Ballpark" style={{ width: '64px', height: '64px' }} />
            </div>
            <h3 style={{ color: '#1f2937', marginBottom: '1.0rem', fontWeight: '600' }}>
              Ballpark Access Denied
            </h3>
            <p style={{ color: '#6b7280', marginBottom: '1.0rem', lineHeight: '1.6' }}>
              You do not have permission to access Ballpark features. Please contact your administrator to request access.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Loading data (after access check passed)
  if (loading) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100vw',
        height: '100vh'
      }}>
        <Spinner size="large" />
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="page-content">
        <div className="alert alert-danger m-4">Error: {error}</div>
      </div>
    );
  }

  const renderContent = () => {
    switch (viewMode) {
      case 'overview':
        return <BallparkOverview {...props} />;
      case 'ballpark':
        return <BallparkTabView {...props} />;
      case 'game':
        return <BallparkGameView {...props} />;
      default:
        return <BallparkOverview {...props} />;
    }
  };

  return (
    <>
      {/* Same top bar as the other verticals */}
      <div className="sticky-top cx-topbar bp-topbar">
        <div>
          <BallparkHeader {...props} />
          {viewMode === 'game' && (
            <GameSelector
              loading={props.loading}
              currentLocation={props.currentLocation}
              currentSeries={props.currentSeries}
              currentGame={props.currentGame}
              currentSeason={props.currentSeason}
              setCurrentSeason={props.setCurrentSeason}
              games={props.games}
              now={props.now}
              isToday={props.isToday}
              setCurrentGame={props.setCurrentGame}
              setCurrentSeries={props.setCurrentSeries}
              setSelectedDate={props.setSelectedDate}
              theme={props.theme}
            />
          )}
        </div>
      </div>

      <div style={{ width: '100%', margin: '0 auto', padding: '1rem' }}>
        {renderContent()}
      </div>
    </>
  );
}

export default Ballpark;